import update from 'immutability-helper';
import bookingOfficeApi from '../lib/api/bookingOffice';
// ------------------------------------
// Constants
// ------------------------------------

export const RECEIVE_BOOKINGOFFICE = 'BOOKINGOFFICE/LOAD_SUCCESS';
export const LOAD_BOOKINGOFFICE = 'BOOKINGOFFICE/LOADING';

export function receiveBookingOffice(bookingOffice) {
	return {
		type: RECEIVE_BOOKINGOFFICE,
		bookingOffice,
	};
}

export function fetchBookingOffice() {
	return async (dispatch, getState) => {
		const bookingOffice = await bookingOfficeApi.getBookingOffice(
			getState().merchant.merchantId, getState().merchant.themeName);
		dispatch(receiveBookingOffice(bookingOffice));
	};
}

export function fetchBookingOfficeIfNeeded() {
	return async(dispatch, getState) => {
		if (!getState().bookingOffice) {
			await dispatch(fetchBookingOffice());
			return Promise.resolve()
		}
		return Promise.resolve();
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[RECEIVE_BOOKINGOFFICE]: (state, action) => update(state, {
		$set: action.bookingOffice,
	}),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = null;

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
